import { fetchHotelsAndAirbnbTermsAndConditionsLogic } from './fetchHotelsAndAirbnbTermsAndConditionsLogic';

export const logic = [fetchHotelsAndAirbnbTermsAndConditionsLogic];
